// extracted by mini-css-extract-plugin
export default {"error":"enterprise-org-settings_error__Ef8Pn"};